const ConnectionError = () => {
  return ( 
    <span>Connection error.</span>
  );
}
 
export default ConnectionError;